// extracted by mini-css-extract-plugin
module.exports = {"blogLayout":"BlogLayout_blogLayout__FFr6U","stageImage":"BlogLayout_stageImage__BRXF0","imageContainer":"BlogLayout_imageContainer__DEMhh"};